// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Appointments Calendar only. Selectors are namespaced so Dashboard/Patients/Chart stay unchanged. */

.emr-apt-cal,
.emr-apt-cal *,
.emr-apt-cal *::before,
.emr-apt-cal *::after,
.emr-apt-cal-popper,
.emr-apt-cal-popper *,
.emr-apt-cal-popper *::before,
.emr-apt-cal-popper *::after,
.emr-apt-dialog,
.emr-apt-dialog *,
.emr-apt-dialog *::before,
.emr-apt-dialog *::after {
  border-radius: 0 !important;
}

.emr-apt-cal-shell,
.emr-apt-cal-main {
  background-color: #E5F0FF !important;
}

.emr-apt-cal {
  background-color: #E5F0FF;
}

.emr-apt-cal .emr-apt-surface {
  border-radius: 0 !important;
}

.emr-apt-cal button,
.emr-apt-cal [data-testid="appointment-calendar-location"] {
  border-radius: 0 !important;
}

.emr-apt-cal [data-testid="appointments-table"] {
  border-radius: 0;
  min-width: 1080px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
}

/*
 * Same accepted clinical density as the patient-chart tables and the Encounters
 * list: Arial, 16px text on a 16px line, 20px data rows, 2px vertical cell
 * padding. This table is built from the shared shadcn Table primitives, so the
 * declarations it has to clear are Tailwind utilities rather than Materialize:
 *   .p-2    -> padding 8px        (TableCell default)
 *   .py-1.5 -> padding 6px        (per-cell in AppointmentsPage)
 *   .h-9    -> height 36px        (per-TableHead in AppointmentsPage)
 * \`.emr-apt-cal [data-testid="appointments-table"] td\` is (0,2,1), which beats
 * those (0,1,0) utilities, and also clears Materialize's
 * \`.emr-mz-dashboard td, th\` (0,1,1) should this page ever gain that chrome.
 * No !important required.
 *
 * Only the vertical box is tightened. Horizontal padding is deliberately left
 * to Tailwind's \`.p-2\` (8px), so the nine columns across the declared 1080px
 * min-width keep their existing rhythm.
 */
.emr-apt-cal [data-testid="appointments-table"] thead tr,
.emr-apt-cal [data-testid="appointments-table"] tbody tr {
  height: 20px;
}

.emr-apt-cal [data-testid="appointments-table"] th,
.emr-apt-cal [data-testid="appointments-table"] td {
  box-sizing: border-box;
  height: 20px;
  max-height: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Status and confirmation chips have to fit the 16px content box the 2px + 2px
   cell padding leaves, exactly like the accepted chart chips. */
.emr-apt-cal .emr-apt-cal__badge {
  display: inline-flex;
  align-items: center;
  height: 16px;
  max-height: 16px;
  padding: 0 4px;
  margin: 0;
  border-width: 0;
  font-size: 16px;
  line-height: 16px;
}

.emr-apt-cal [data-testid="appointments-table"] [class*="inline-flex"],
.emr-apt-dialog [class*="inline-flex"] {
  border-radius: 0 !important;
}

.emr-apt-dialog {
  border-radius: 0 !important;
}

.emr-apt-dialog button {
  border-radius: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-appointments-calendar.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE;AACF;;EAEE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;gEACgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Appointments Calendar only. Selectors are namespaced so Dashboard/Patients/Chart stay unchanged. */\n\n.emr-apt-cal,\n.emr-apt-cal *,\n.emr-apt-cal *::before,\n.emr-apt-cal *::after,\n.emr-apt-cal-popper,\n.emr-apt-cal-popper *,\n.emr-apt-cal-popper *::before,\n.emr-apt-cal-popper *::after,\n.emr-apt-dialog,\n.emr-apt-dialog *,\n.emr-apt-dialog *::before,\n.emr-apt-dialog *::after {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal-shell,\n.emr-apt-cal-main {\n  background-color: #E5F0FF !important;\n}\n\n.emr-apt-cal {\n  background-color: #E5F0FF;\n}\n\n.emr-apt-cal .emr-apt-surface {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal button,\n.emr-apt-cal [data-testid=\"appointment-calendar-location\"] {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal [data-testid=\"appointments-table\"] {\n  border-radius: 0;\n  min-width: 1080px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n}\n\n/*\n * Same accepted clinical density as the patient-chart tables and the Encounters\n * list: Arial, 16px text on a 16px line, 20px data rows, 2px vertical cell\n * padding. This table is built from the shared shadcn Table primitives, so the\n * declarations it has to clear are Tailwind utilities rather than Materialize:\n *   .p-2    -> padding 8px        (TableCell default)\n *   .py-1.5 -> padding 6px        (per-cell in AppointmentsPage)\n *   .h-9    -> height 36px        (per-TableHead in AppointmentsPage)\n * `.emr-apt-cal [data-testid=\"appointments-table\"] td` is (0,2,1), which beats\n * those (0,1,0) utilities, and also clears Materialize's\n * `.emr-mz-dashboard td, th` (0,1,1) should this page ever gain that chrome.\n * No !important required.\n *\n * Only the vertical box is tightened. Horizontal padding is deliberately left\n * to Tailwind's `.p-2` (8px), so the nine columns across the declared 1080px\n * min-width keep their existing rhythm.\n */\n.emr-apt-cal [data-testid=\"appointments-table\"] thead tr,\n.emr-apt-cal [data-testid=\"appointments-table\"] tbody tr {\n  height: 20px;\n}\n\n.emr-apt-cal [data-testid=\"appointments-table\"] th,\n.emr-apt-cal [data-testid=\"appointments-table\"] td {\n  box-sizing: border-box;\n  height: 20px;\n  max-height: 20px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  vertical-align: middle;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* Status and confirmation chips have to fit the 16px content box the 2px + 2px\n   cell padding leaves, exactly like the accepted chart chips. */\n.emr-apt-cal .emr-apt-cal__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  max-height: 16px;\n  padding: 0 4px;\n  margin: 0;\n  border-width: 0;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-apt-cal [data-testid=\"appointments-table\"] [class*=\"inline-flex\"],\n.emr-apt-dialog [class*=\"inline-flex\"] {\n  border-radius: 0 !important;\n}\n\n.emr-apt-dialog {\n  border-radius: 0 !important;\n}\n\n.emr-apt-dialog button {\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
